import React from "react";
import { Box, Modal, Typography } from "@mui/material";
import CustomDarkButton from "../buttons/CustomDarkButton";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import dayjs from "dayjs";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const PassengerDeletionConfirmationModal = ({
  open,
  onAccept,
  title = null,
  onClose,
  date,
  name,
  passengersNumber,
  relationFrom,
  relationTo,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box>
          <Box sx={{ marginBottom: "1rem" }}>
            <Typography
              sx={{
                fontSize: "1.5rem",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              {title}
            </Typography>
          </Box>
          <Box sx={{ marginBottom: "1rem" }}>
            <p>{dayjs(date).format("DD/MM/YYYY")}</p>
            <p>
              {relationFrom} - {relationTo}
            </p>
            <p>{passengersNumber} osobe</p>
            <p>{name}</p>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CustomDarkButton
              handleClick={onAccept}
              title={<CheckIcon />}
              className="w-fit-content ms-2"
            />
            <CustomDarkButton
              handleClick={onClose}
              title={<ClearIcon />}
              className="w-fit-content ms-2"
            />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default PassengerDeletionConfirmationModal;
